export enum SurveyMailContactTypeEnum {
    ALL_CONTACTS = 'a4eb0efa-755c-44ca-ba98-fcaff329e5e3',
    CONTACT_TYPES = '9f84eeb1-d839-4bd4-aed5-a10be11250a7',
    RANDOM = 'ad0aba2a-f6d6-4e6a-b86b-f3ce90364c15',
    DO_NOT_SEND = '296a0b3b-c8fb-493c-b5c0-f209bee36142',
    RANDOM_SECOND = 'f738632d-f251-4f76-aae7-ff0d73732faf'
}
